import {
  AppstoreOutlined,
  BankOutlined,
  DatabaseOutlined,
  HomeOutlined,
  PlusOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons'

const modules = [
  {
    id: 'pagstix',
    name: 'PagStix',
    description: 'Sistema de pagamentos de pontos da Stix.',
    iconElement: <HomeOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/pagstix',
    color: '#ff007f',
  },
  {
    id: 'marketplace',
    name: 'Marketplace',
    description: 'Plataforma de compras e vendas.',
    iconElement: <AppstoreOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/marketplace',
    color: '#00b140',
  },
  {
    id: 'accrual',
    name: 'Acúmulo',
    description: 'Sistema de acúmulo de pontos e recompensas.',
    iconElement: <PlusOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/accrual',
    color: '#00b2ff',
  },
  {
    id: 'riskengine',
    name: 'Análise de Riscos',
    description: 'Sistema de análise de riscos.',
    iconElement: <WarningOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/riskengine',
    color: '#0047ab',
  },
  {
    id: 'onboarding',
    name: 'Cadastro',
    description: 'Sistema de cadastro de membros.',
    iconElement: <UserOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/onboarding',
    color: '#8100d1',
  },
  {
    id: 'streaming',
    name: 'Streaming',
    description: 'Streaming de Dados.',
    iconElement: <DatabaseOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/streaming',
    color: '#F2CB15',
  },
  {
    id: 'digital',
    name: 'Canais Digitais',
    description: 'Sistema de canais digitais.',
    iconElement: <BankOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/digital',
    color: '#F46700',
  },
  {
    id: 'plis',
    name: 'Plis',
    description: 'Motor de pontos Stix.',
    iconElement: (() => {
      const wrapper: React.CSSProperties = {
        display: 'grid',
        position: 'relative',
      }

      const childStyle: React.CSSProperties = {
        gridColumn: 1,
        gridRow: 1,
        color: '#1976d2',
        margin: 'auto',
      }

      const biggerCogStyle: React.CSSProperties = {
        fontSize: 40,
        translate: '-10px 10px',
      }

      const smallerCogStyle: React.CSSProperties = {
        fontSize: 20,
        translate: '10px -10px',
      }

      return (
        <div style={wrapper}>
          <SettingOutlined style={{...childStyle, ...biggerCogStyle}}/>
          <SettingOutlined style={{...childStyle, ...smallerCogStyle}}/>
        </div>
      )
    })(),
    path: '/plis',
    color: '#131313',
  },
]

if (import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'test') {
  modules.push({
    id: 'example',
    name: 'Example',
    description: 'Example',
    iconElement: <TeamOutlined style={{fontSize: 40, color: '#1976d2'}} />,
    path: '/example',
    color: '#0047ab',
  })
}

export {modules}
